export default __webpack_public_path__ + "static/media/twitter.9d4a9d7f.svg";